import {
  Component,
  HostListener,
  NgZone,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { combineLatest, filter, map } from 'rxjs/operators';
import { AuthUser } from 'src/app//shared/models/auth/AuthUser';
import { SignalEventType } from 'src/app//shared/models/SignalModel';
import { RolesEnum } from 'src/app//shared/models/users/roles/enums/roles';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { SignalRService } from 'src/app/shared/services/signal-rservice.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  logo = './assets/images/logo/logo.png';
  moduleLoading!: boolean;
  forExtract = false;
  hideFooter = false;
  currencyLoading!: boolean;
  currentUser: AuthUser | null = new AuthUser();
  hiddenFooterURLS = ['/admin/discussion-forum'];
  checkoutId: any = null;
  educationCenterLoading = false;
  subscriptions: Subscription[] = [];


  constructor(
    public navService: NavigationService,
    public router: Router,
    public zone: NgZone,
    private signalRService: SignalRService,
    // private currencyService: CurrencyService,
    // private hpPyementService: HPayementService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private dialog: MatDialog,
    private auth: AuthenticationService,
    // private coursesIntegrationService: CoursesIntegrationService,
    // private homepageService: HomepageService
  ) {
    this.signalRService.startConnection();
    // router.events.subscribe((event: RouterEvent) => {
    //   this.navigationInterceptor(event);
    //   this.hideFooter = this.hiddenFooterURLS.includes(this.router.url) && !this.hasPermission(RolesEnum.Trainee);
    // });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((routeChange: any) => {
      // console.log(routeChange.id, routeChange.url, routeChange.urlAfterRedirects);
      // if (routeChange.url.includes('assessmentType=PATHOLOGY_ANATOMY') && routeChange.url.includes('/viewer')) {
      //   localStorage.setItem('canAccessExam', 'true');
      // }

      if (this.isMobile()) {
        this.navService.sidebarState.sidenavOpen = false;
      }
      this.navigationInterceptor(routeChange);
      this.hideFooter = this.hiddenFooterURLS.includes(this.router.url) && !this.hasPermission(RolesEnum.Trainee);
      this.forExtract = this.router.url.includes('/admin/courses') || this.router.url.includes('/admin/anatomic-pathology-exams-trainee') || this.hasPermission(RolesEnum.Trainee);
    });
    this.currentUser = this.auth.currentUserValue;
    // this.defaultCurrency = this.currencyService.defaultCurrencyValue;
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.signalRService.getDataStream<string>(SignalEventType.newLabUpdate)
        .subscribe(message => { this.labUpdated(message.data); })
    )
    this.updateSidebar();

    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.checkoutId = params.get('id');
      if (this.checkoutId) {
        // this.getCheckoutStatus();
      }
    });

    // this.getDefaultCurrency();
    // this.getEntityHomepageDetailsforUser();
    // console.log(window.location);
  }

  // getDefaultCurrency() {
  //   this.currencyLoading = true;
  //   this.currencyService.getDefaultCurrency().subscribe(
  //     (data: DefaultCurrency) => {
  //       this.currencyLoading = false;
  //       this.currencyService.defaultCurrencySubject.next(data);
  //       localStorage.setItem('defaultCurrency', JSON.stringify(data));
  //     },
  //     (err: any) => {
  //       console.error(err);
  //     }
  //   );
  // }

  // getEntityHomepageDetailsforUser() {
  //   this.educationCenterLoading = true;
  //   this.homepageService.getEntityHomepageDetailsforUser().subscribe(
  //     (data: Details) => {
  //       this.educationCenterLoading = false;
  //       if (data) {
  //         this.educationCenterDetails = {
  //           ...data,
  //           generalTheme: JSON.parse(String(data.generalTheme)),
  //           heroAreaSection: JSON.parse(String(data.heroAreaSection)),
  //         };
  //         this.changeColor('--admin-primary-bg', this.educationCenterDetails.generalTheme.primaryColor.background);
  //         this.changeColor('--admin-primary-color', this.educationCenterDetails.generalTheme.primaryColor.foreground);
  //         this.changeColor('--admin-secondary-bg', this.educationCenterDetails.generalTheme.primaryColor.background);
  //         this.changeColor('--admin-secondary-color', this.educationCenterDetails.generalTheme.primaryColor.foreground);
  //         this.logo = this.educationCenterDetails.logo;
  //       }
  //     },
  //     (err: any) => {
  //       this.educationCenterLoading = false;
  //       console.error(err);
  //     }
  //   );
  // }

  changeColor(key: string, value: string): void {
    // console.log(document.body)
    document.body.style.setProperty(key, String(value));
  }

  labUpdated(data: any) {
    if (this.currentUser && this.currentUser.ObjectValue === data.labId) {
      this.auth.RefeshUserToken(true).subscribe((data: any) => { });
    }
  }

  isMobile() {
    return window && window.matchMedia('(max-width: 500px)').matches;
  }

  // Shows and hides the moduleLoading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.moduleLoading = true;
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => {
        // here
        this.moduleLoading = false;
      }, 100);
    }

    // Set moduleLoading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      setTimeout(() => {
        // here
        this.moduleLoading = false;
      }, 100);
    }
    if (event instanceof NavigationError) {
      setTimeout(() => {
        // here
        this.moduleLoading = false;
      }, 100);
    }
  }

  updateSidebar() {
    if (this.isMobile()) {
      this.navService.sidebarState.sidenavOpen = false;
    } else {
      this.navService.sidebarState.sidenavOpen = true;
    }
  }


  // getPricingPackages(id: any) {
  //   this.coursesIntegrationService.getPricingPackages().subscribe(
  //     (data: any) => {
  //       this.recordsData = data.pageDate;
  //       const record = this.recordsData.find(record => record.id == id)
  //       this.subscripPlan(record)
  //     },
  //     (error: any) => {
  //     }
  //   );
  // }


  // getCheckoutStatus() {
  //   const query = {
  //     chechoutId: this.checkoutId,
  //     trycount: 0,
  //   };
  //   this.hpPyementService.getCheckoutStatus(query).subscribe(
  //     (data: any) => {
  //       if (data && data.status && data.status == PaymentStatusEnum.Succeeded) {
  //         const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
  //           width: '750px',
  //           data: {
  //             img: 'assets/images/icons/done_illustration.svg',
  //             title: this.translate.instant('pricing.subscriptionSuccess'),
  //             message: `${this.translate.instant('pricing.YoureSubscribedTo')} <strong>'${data.objectName} - ${data.price} ${this.translate.instant('pricing.SARPerYear')}'</strong> ${this.translate.instant('pricing.plan')}`,
  //             btnTitle: this.translate.instant('trainee.done'),
  //             btnClass: 'w-50',
  //             btnCancel: false,
  //           },
  //         });
  //         dialogRef.afterClosed().subscribe((result: any) => {
  //           this.auth.RefeshUserToken(true, true).subscribe((data: any) => {

  //           }, (err: any) => {
  //             this.auth.logout();
  //           });
  //         });

  //       } else {
  //         const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
  //           width: '750px',
  //           data: {
  //             img: 'assets/images/icons/illustration_failed.svg',
  //             title: this.translate.instant('pricing.transactionFailed'),
  //             message: this.translate.instant('pricing.declinedMessage'),
  //             btnTitle: this.translate.instant('pricing.tryAgainButton'),
  //             btnClass: 'w-50',
  //             btnCancel: true,
  //             btnCancelClass: 'w-50',
  //           },
  //         });
  //         dialogRef.afterClosed().subscribe((result: any) => {
  //           if (result) {
  //             this.getPricingPackages(data.objectId)
  //           }
  //         });
  //       }
  //       this.router.navigate([this.router.url.split('?')[0]], {
  //         replaceUrl: true,
  //       });
  //     },
  //     (err: any) => { },
  //   );
  // }


  // openPricingPackages() {
  //   const dialogRef = this.dialog.open(PricingPackagesComponent, {
  //     width: '1010px',
  //     height: 'auto',
  //     data: {},
  //   });
  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if (result) {
  //       this.subscripPlan(result)
  //     }
  //   });
  // }

  // subscripPlan(data: any) {
  //   const dialogRef = this.dialog.open(SubscripePlanComponent, {
  //     width: '650px',
  //     data,
  //   });
  //   dialogRef.afterClosed().subscribe((result: any) => {

  //   });
  // }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateSidebar();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    /* if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    } */
  }
}
